(() => {
  'use strict';

  const loader = document.currentScript;
  if (!loader || !window.matchMedia || !window.IntersectionObserver) return;

  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const urls = { gsap: loader.dataset.gsapUrl, motion: loader.dataset.motionUrl };
  const requests = new Map();

  const loadScript = (url) => {
    if (!url) return Promise.reject(new Error('Missing motion asset URL'));
    if (requests.has(url)) return requests.get(url);

    const request = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        requests.delete(url);
        reject(new Error('Motion asset could not be loaded'));
      };
      document.head.appendChild(script);
    });
    requests.set(url, request);
    return request;
  };

  const needed = () => !preference.matches && document.querySelector('[data-oss-reveal]');
  const initialize = () => {
    if (window.OssMotion || !needed()) return;
    const library = window.gsap ? Promise.resolve() : loadScript(urls.gsap);
    library.then(() => {
      if (!window.OssMotion && needed()) return loadScript(urls.motion);
    }).catch(() => {});
  };

  document.addEventListener('shopify:section:load', initialize);
  preference.addEventListener('change', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
